import { FC, memo } from 'react';

import { useFeaturesManagement } from './hooks/useFeaturesManagement';
import { FeaturesProviderProps } from './types/FeaturesProviderProps';
import { FeaturesContext } from './FeaturesContext';

const FeaturesProviderComponent: FC<FeaturesProviderProps> = ({ children }) => {
  const { value, isLoading } = useFeaturesManagement();

  if (isLoading) {
    return null;
  }

  return (
    <FeaturesContext.Provider value={value}>
      {children}
    </FeaturesContext.Provider>
  );
};

export const FeaturesProvider = memo(FeaturesProviderComponent);
